// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"54ec4e00","182":"843a9fce","453":"e508ab7a"}[chunkId] + ".chunk.js";
};